module.exports = __webpack_public_path__ + "img/banner2.1ff3a36c.jpg";